export default "__VITE_ASSET__ftPuJMQJ__"